var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulseFaqHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 0C8.91374 0 0.75 8.16238 0.75 18.25V35.0742C0.75 35.8617 1.38832 36.5 2.17578 36.5H19C29.0862 36.5 37.25 28.3376 37.25 18.25C37.25 8.16374 29.0876 0 19 0ZM19 33.6484H3.60156V18.25C3.60156 9.73973 10.4886 2.85156 19 2.85156C27.5103 2.85156 34.3984 9.73859 34.3984 18.25C34.3984 26.7603 27.5114 33.6484 19 33.6484ZM20.3543 26.3812C20.3543 27.4001 19.5094 28.2946 18.441 28.2946C17.3725 28.2946 16.5524 27.4 16.5524 26.3812C16.5524 25.3376 17.3974 24.4678 18.441 24.4678C19.4847 24.4678 20.3543 25.3376 20.3543 26.3812ZM24.057 14.0808C24.057 16.4167 21.9447 18.1064 21.2738 18.6283C19.9072 19.6967 19.8822 20.4422 19.8822 21.7344C19.8822 22.2065 19.6338 22.7532 18.4161 22.7532C17.3973 22.7532 17.0495 22.3804 17.0495 21.0883C17.0495 18.9513 17.9938 17.9324 18.7143 17.3112C19.5344 16.6154 20.9259 15.8451 20.9259 14.5032C20.9259 13.3601 19.932 12.8134 18.6895 12.8134C16.1549 12.8134 16.7015 14.7268 15.3597 14.7268C14.6887 14.7268 13.8688 14.2796 13.8688 13.3104C13.8688 11.9685 15.4094 9.98061 18.764 9.98061C21.9447 9.98061 24.057 11.7449 24.057 14.0808Z",
    fill: "url(#paint0_linear_1_53)",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_53",
    x1: 19,
    y1: 0,
    x2: 19,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35FFB6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5,
    height: 36.5,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseFaqHelp);
export default __webpack_public_path__ + "static/media/pulse-faq-help.5a02e94abf21b3d46a5708ef3316dfc7.svg";
export { ForwardRef as ReactComponent };